export const PublicSettings = {
  PREFIX: 'UI-SERVERLESS.PUBLIC.ORDERLINEPREFIX',
  COMPANYNAME: 'UI-SERVERLESS.PUBLIC.NAME',
  MAPSKEY: 'UI-SERVERLESS.PUBLIC.MAPSKEY',
  WEBSITE: 'UI-SERVERLESS.PUBLIC.WEBSITE'
};
